import { render, staticRenderFns } from "./Autobiography.vue?vue&type=template&id=e8422642&scoped=true"
import script from "./Autobiography.vue?vue&type=script&lang=js"
export * from "./Autobiography.vue?vue&type=script&lang=js"
import style0 from "./Autobiography.vue?vue&type=style&index=0&id=e8422642&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8422642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8422642')) {
      api.createRecord('e8422642', component.options)
    } else {
      api.reload('e8422642', component.options)
    }
    module.hot.accept("./Autobiography.vue?vue&type=template&id=e8422642&scoped=true", function () {
      api.rerender('e8422642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/DL/Autobiography.vue"
export default component.exports